import { render, staticRenderFns } from "./ModelReceipt.vue?vue&type=template&id=7636d127&"
import script from "./ModelReceipt.vue?vue&type=script&lang=js&"
export * from "./ModelReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports